import { useQuery } from "@tanstack/react-query";
import { useField } from "formik";
import AutoComplete from "../autocomplete/Autocomplete";
import { useState } from "react";
import AutoCompleteSelectedItem from "../autocomplete/AutoCompleteSelectedItem";
import { getForsikringsselskaber } from "../../api/tilsynserklaering";
import { Forsikringsselskab } from "../../interfaces/tilsynserklaering";

export default function ForsikringsselskabField({
  name,
  isInvalid,
}: {
  name: string;
  isInvalid?: boolean;
}) {
  const [inputValue, setInputValue] = useState<string>("");
  const [field, meta, helpers] = useField<Forsikringsselskab | undefined>(name);

  const { data: forsikringsselskaber, isLoading } = useQuery<
    Forsikringsselskab[]
  >({
    queryKey: ["forsikringsselskaber"],
    queryFn: async () => {
      return getForsikringsselskaber();
    },
  });

  let items = forsikringsselskaber
    ? [
        ...forsikringsselskaber
          .filter((f) => {
            return f.navn.toLowerCase().includes(inputValue.toLowerCase());
          })
          .sort((a, b) => {
            return a.navn.localeCompare(b.navn);
          }),
        {
          id: "andet",
          navn: "Andet forsikringsselskab",
          cvr: "",
          sidstOpdateret: new Date().toISOString(),
        },
      ]
    : [];
  if (items.length > 0) {
    items = [
      {
        id: "ingen",
        navn: "Ingen nuværende forsikring",
        cvr: "",
        sidstOpdateret: new Date().toISOString(),
      },
      ...items,
    ];
  }

  const selectedItem = items.find((i) => i.id === meta.value?.id);
  if (selectedItem) {
    return (
      <AutoCompleteSelectedItem
        onClick={() => {
          helpers.setValue(undefined);
          helpers.setError(name);
        }}
        title={selectedItem.navn}
      />
    );
  }
  return (
    <AutoComplete
      inputId={name}
      loading={isLoading}
      itemToElement={(item) => <div className="p-2">{item.navn}</div>}
      items={items}
      itemToString={(item) => item?.navn ?? ""}
      onSelectedItemChange={({ selectedItem }) => {
        helpers.setValue(selectedItem ?? undefined);
        helpers.setTouched(true);
      }}
      setInputValue={setInputValue}
      fieldInputProps={field}
      isInvalid={isInvalid}
    />
  );
}
